import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoes.vue?vue&type=template&id=5f081bfa&"
import script from "./PlanejamentoContratoFormAcoes.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoContratoFormAcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports